export default __webpack_public_path__ + "static/media/1185.d096b636.png";